import { render, staticRenderFns } from "./UpdateForm.vue?vue&type=template&id=447463bc&scoped=true"
import script from "./UpdateForm.vue?vue&type=script&lang=js"
export * from "./UpdateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447463bc",
  null
  
)

export default component.exports